import moment from 'moment';

const formatLineData = (dataArray: any) => {
  dataArray.sort((a: any, b: any) => {
    return moment(a.date, 'YYYY-MM-DD').diff(moment(b.date, 'YYYY-MM-DD'));
  });
  const sources: string[] = Array.from(new Set(dataArray.map((item) => item.source)));
  const dates: string[] = Array.from(new Set(dataArray.map((item) => item.date)));
  const seriesData: any[] = sources.map((source) => {
    return {
      name: source,
      type: 'line',
      data: dataArray
        .filter((item) => item.source === source)
        .map((item) => [item.date, item.value]),
    };
  });
  return {
    series: seriesData,
    sources,
    dates,
  };
};

export const getLineData = (data: any, selected: string) => {
  const impactedData: any = [];
  if (selected === 'kpiSampleSize') {
    const combinationMap: any = {};
    data.forEach((item: any) => {
      const itemDate = moment(item.starttime, 'YYYY-MM-DD HH:mm:ss.SSS').format('YYYY-MM-DD');
      const key = `${item.resource}_${itemDate}`;
      if (key in combinationMap) {
        // If the combination exists, update the results
        impactedData[combinationMap[key]].value += Number(item.kpisamplesize);
      } else {
        // If the combination is new, add to results and update the map
        combinationMap[key] = impactedData.length;
        impactedData.push({
          source: item.resource,
          value: Number(item.kpisamplesize),
          date: itemDate,
        });
      }
    });
  } else {
    const combinationMap: any = {};
    data.forEach((item: any) => {
      const itemDate = moment(item.starttime, 'YYYY-MM-DD HH:mm:ss.SSS').format('YYYY-MM-DD');
      const key = `${item.resource}_${itemDate}`;
      if (key in combinationMap) {
        // If the combination exists, update the results
        impactedData[combinationMap[key]].value += Number(item.totaltime);
        impactedData[combinationMap[key]].value += Number(item.kpisamplesize);
      } else {
        // If the combination is new, add to results and update the map
        combinationMap[key] = impactedData.length;
        impactedData.push({
          source: item.resource,
          value: Number(item.totaltime),
          date: itemDate,
        });
      }
    });
  }
  const dataToReturn: any = formatLineData(impactedData);
  return dataToReturn;
};

export const buildLineOption = (data: any, type: string) => {
  const { series, sources, dates } = data;
  return {
    xAxis: {
      type: 'category',
      data: dates,
    },
    yAxis: {
      type: 'value',
    },
    series,
    tooltip: {
      trigger: 'axis',
      formatter: (params: any) => {
        const date = params[0].data[0];
        let content = `<div>${date}</div>`;
        params.forEach((param: any) => {
          content += `<div style="text-align:left;margin: 3px;">${param.marker} ${param.seriesName}: <b>${param.data[1]} ${type === 'duration' ? 'min' : ''}</b></div>`;
        });
        return content;
      },
    },
    legend: {
      data: sources,
    },
  };
};
